import React from "react";
import "./ComingSoon.css";

const ComingSoon: React.FC = () => (
  <main className="coming-soon-page">
    <div className="coming-soon-glow coming-soon-glow-left" />
    <div className="coming-soon-glow coming-soon-glow-right" />

    <section className="coming-soon-content" aria-labelledby="coming-soon-title">
      <img
        className="coming-soon-logo"
        src="/logo-app.png"
        alt="Mamadoc"
      />
      <p className="coming-soon-eyebrow">Mamadoc</p>
      <h1 id="coming-soon-title">Work in progress</h1>
      <p className="coming-soon-message">Stiamo arrivando.</p>
      <p className="coming-soon-description">
        Stiamo preparando qualcosa di nuovo per rendere più semplice la gestione delle tue pratiche.
      </p>
      <div className="coming-soon-line" aria-hidden="true" />
      <p className="coming-soon-footer">mamadoc.it</p>
    </section>
  </main>
);

export default ComingSoon;
